/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const LABEL_EXPANDED_TRANSITION = 'max-width 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s ease 0.08s'

export const LABEL_COLLAPSED_TRANSITION = 'max-width 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.08s ease'

export const ACTIVE_BAR_CLASS = 'bg-primary'
